export default {"src":"/_next/static/media/wchz.84bf5624.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};